import React, { useState } from 'react';
import style from '../content-list.module.scss';
import InfiniteScroll from "react-infinite-scroll-component";
import AddIcon from '../../../../../../../../assets/svg/solo-chat/circle-plus.svg';
import { Markdown  } from './Markdown';
import { Markdown as TMarkdown } from '../../types';
import { AddMarkdown } from './AddMarkdown';
import { usePermissions } from '../../../../hooks';

type Props = {
	scrollRef:any|null;
	contents: (TMarkdown & { id: string; updatedAt: string|null; createdAt: string })[];
	hasMore:boolean;
	refetchContent: () => void;
	loadMore: () => void;
};

export function MarkdownList(props: Props) {
	const { scrollRef, contents, hasMore, refetchContent, loadMore } = props;
	return (
		<div className={style.contentList}>
			<Header {...props} />
			<div className={style.selector}>
				<div>
					<p>Markdown</p>
				</div>
				<p>Updated At</p>
				<p>Created At</p>
			</div>
			<div id="infiniteScrollTarget" ref={scrollRef} className={style.textList} style={{overflow: "auto", height: "calc(100vh - 200px)"}}>
				{contents.length>0?
					<InfiniteScroll
						scrollableTarget="infiniteScrollTarget"
						dataLength={contents.length}
						next={loadMore}
						hasMore={hasMore}
						loader={<div className={style.loadingContainer}> Loading...</div>}>
						{contents.map((el) => (
							<Markdown key={el.id} markdown={el} refetchContent={refetchContent} />
						))}
					</InfiniteScroll>
				:
					null
				}
			</div>
		</div>
	);
}

function Header(props: Props) {
	const [isOpen, setIsOpen] = useState(false);
	const canCreate = usePermissions('content.Create')
	return (
		<div className={style.header}>
			{canCreate &&
				<button className={style.add} onClick={() => setIsOpen(true)}>
					<img src={AddIcon} alt="add" />
					<span>Add Markdown</span>
				</button>
			}
			{isOpen && (
				<AddMarkdown
					isOpen={isOpen}
					close={() => setIsOpen(false)}
					refetchContent={props.refetchContent}
				/>
			)}
		</div>
	);
}
